'use strict';
import * as $j_java$002eio$002e$002dFilter$002dOutput$002dStream from "./java.io.-Filter-Output-Stream.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
function $ct_Ljava_io_PrintStream__Ljava_io_OutputStream__Z__Ljava_nio_charset_Charset__($thiz, _out, autoFlush, charset) {
  $j_java$002eio$002e$002dFilter$002dOutput$002dStream.$ct_Ljava_io_FilterOutputStream__Ljava_io_OutputStream__($thiz, _out);
  return $thiz;
}
export { $ct_Ljava_io_PrintStream__Ljava_io_OutputStream__Z__Ljava_nio_charset_Charset__ as $ct_Ljava_io_PrintStream__Ljava_io_OutputStream__Z__Ljava_nio_charset_Charset__ };
/** @constructor */
function $c_Ljava_io_PrintStream() {
}
export { $c_Ljava_io_PrintStream as $c_Ljava_io_PrintStream };
$p = $c_Ljava_io_PrintStream.prototype = new $j_java$002eio$002e$002dFilter$002dOutput$002dStream.$h_Ljava_io_FilterOutputStream();
$p.constructor = $c_Ljava_io_PrintStream;
/** @constructor */
function $h_Ljava_io_PrintStream() {
}
export { $h_Ljava_io_PrintStream as $h_Ljava_io_PrintStream };
$h_Ljava_io_PrintStream.prototype = $p;
$p.Sg = (function(csq) {
  this.WG(((csq === null) ? "null" : $j_java$002elang$002e$002dObject.$dp_toString__T(csq)));
  return this;
});
$p.NY = (function(csq) {
  return this.Sg(csq);
});
